import { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import { Loading } from "../../components/Elements/Loading";
import TransactionDetail from "./transactionDetails";

const Dashboard = lazy(() => import(`./DasshboardPage`));

const DashboardViews = () => {
  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        <Route
          path="/"
          element={<Dashboard title="Dashboard" />}
        />
        <Route
          path="/transaction/:id"
          element={<TransactionDetail title="Dashboard" />}
        />
      </Routes>
    </Suspense>
  );
};

export default DashboardViews;
